import type { FC } from 'react';

import Trash2 from '@crehana/compass.icons.outline/Trash2';
import { useTranslation } from '@crehana/i18n';

import type { TableContainerProps } from '../../types';

type TSelectedRecordsActionsProps = Pick<
  TableContainerProps,
  'recordsSelected' | 'onDelete' | 'actions'
> & {
  withContainer?: boolean;
};

//TODO: Extend functionality to allow enhanced actions
const SelectedRecordsActions: FC<TSelectedRecordsActionsProps> = ({
  recordsSelected,
  onDelete,
  actions,
  withContainer,
}) => {
  const { t } = useTranslation();

  // biome-ignore lint/style/useBlockStatements: single-line early return
  if (!recordsSelected) return null;

  const containerClassname = withContainer
    ? 'tw-flex tw-items-center tw-mx-2.4 tw-mt-2 tw-px-3.2 tw-py-1 dark:tw-bg-elevation-dark-04 tw-border-solid tw-border-l-primary-light-500 tw-border-l-[3px]'
    : 'tw-flex tw-ml-2';

  return (
    <div className={containerClassname}>
      <p>
        <span className="tw-font-subtitle5 tw-mr-0.4">{recordsSelected}</span>
        <span className="tw-font-body5">{t('TABLE_CONTAINER_SELECTED')}</span>
      </p>
      <div className="tw-mx-1.2 tw-h-3.2 tw-border-solid tw-border-l-neutral-light-600 dark:tw-border-l-neutral-dark-600 tw-border-l-[1px]"></div>
      <button
        onClick={onDelete}
        type="button"
        className="tw-flex tw-items-center tw-text-neutral-light-700  dark:tw-text-neutral-dark-500 tw-font-link1 hover:tw-text-alert-300 hover:dark:tw-text-alert-300"
      >
        <Trash2 size={18} className="tw-mr-0.8" />
        {t('TABLE_CONTAINER_DELETE')}
      </button>
      {actions}
    </div>
  );
};

export default SelectedRecordsActions;
